import { SelectionValueType } from '@/types/selection.types';

export const SELECTION_DEFAULT_VALUES: Record<SelectionValueType, any> = {
  string: undefined,
  guid: '00000000-0000-0000-0000-000000000000',
  optionalEnum: 0,
};
